import React from "react";
import { connect, useSelector } from "react-redux";
import ProfilesGrid from "../../components/ProfilesGrid/ProfilesGrid";
import NoGroupProfileView from "../../components/ProfilesPage/NoGroupProfileView";
import "./profiles.scss";
import ProfilesBanner from "./ProfilesBanner";

function Profiles(props) {

    const user = useSelector((state) => state.appReducer.userDataReducer.data);

    return (
      <div className="grey-content-container">
        <ProfilesBanner />
        <div className="usa-profile-header">
          <div className="usa-header-profile">
            <h3 className="usa-flag-page-header">Profiles</h3>
            <h4 className="usa-flag-page-subheader">
              Store application information in re-usable profiles to fill
              application sections quickly and consistently.
            </h4>
          </div>
        </div>
        {user.Group.id === null ? <NoGroupProfileView /> : <ProfilesGrid />}
      </div>
    );
  }

export default Profiles;
